// Shared currency formatter for the wallet frontend.
// Extracted from pages/SendMoneyPage.tsx to ensure every flow formats ZAR
// identically (locale en-ZA, 2 decimals, "R" prefix with a space).

/**
 * Format a ZAR amount (in rands, not cents) as a display string.
 * Negative amounts render as "R -123.00" (sign after the R, matching
 * the existing wallet frontend convention).
 *
 * Example: formatCurrency(1234.5) -> "R 1,234.50"
 */
export function formatCurrency(amount: number): string {
  if (!amount && amount !== 0) {
    return 'R 0.00';
  }

  const formattedAmount = Math.abs(amount).toLocaleString('en-ZA', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  if (amount < 0) {
    return `R -${formattedAmount}`;
  }

  return `R ${formattedAmount}`;
}

/**
 * Format a ZAR amount given in cents (canonical integer representation).
 *
 * Example: formatCurrencyFromCents(12345) -> "R 123.45"
 */
export function formatCurrencyFromCents(cents: number): string {
  return formatCurrency(cents / 100);
}

/**
 * Convert a rands amount (number, possibly fractional) to canonical cents.
 * Rounds to the nearest cent to avoid float drift.
 *
 * Example: randsToCents(12.345) -> 1235
 */
export function randsToCents(rands: number): number {
  return Math.round(rands * 100);
}
